
import React from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle } from "@/components/ui/card";
import { X, ArrowLeft, Home } from "lucide-react";

const PaymentCancelPage = () => {
  const navigate = useNavigate();
  
  return (
    <div className="container mx-auto px-4 py-24 max-w-3xl">
      <Card className="border-yellow-200 bg-yellow-50 dark:bg-yellow-900/20 dark:border-yellow-900/50">
        <CardHeader className="text-center">
          <div className="flex justify-center mb-6">
            <div className="rounded-full bg-yellow-100 p-4 dark:bg-yellow-900/50">
              <X className="h-12 w-12 text-yellow-600 dark:text-yellow-400" />
            </div>
          </div>
          <CardTitle className="text-3xl">Pagamento Cancelado</CardTitle>
          <CardDescription className="text-base mt-2">
            O processo de pagamento foi cancelado.
          </CardDescription>
        </CardHeader>
        <CardContent className="space-y-4">
          <div className="text-center text-muted-foreground">
            <p>
              Seu pagamento não foi processado pois o processo foi cancelado. 
              Você pode tentar novamente quando desejar.
            </p>
            
            <div className="mt-6 space-y-2">
              <p className="font-medium">Possíveis motivos para cancelamento:</p>
              <ul className="text-sm space-y-1">
                <li>Você clicou em cancelar durante o processo</li>
                <li>Houve um problema com seu método de pagamento</li>
                <li>Ocorreu um problema técnico durante o processamento</li>
              </ul>
            </div>
          </div>
        </CardContent>
        <CardFooter className="flex flex-col gap-3">
          <Button 
            className="w-full" 
            variant="outline"
            onClick={() => navigate(-1)}
          >
            <ArrowLeft className="mr-2 h-4 w-4" />
            Voltar e tentar novamente
          </Button>
          
          <Button 
            className="w-full" 
            onClick={() => navigate("/")}
          >
            <Home className="mr-2 h-4 w-4" />
            Ir para Página Inicial
          </Button>
        </CardFooter>
      </Card>
    </div>
  );
};

export default PaymentCancelPage;
